import useCartModelChange from "@src/backbone/hooks/useCartModelChange";
import { useMemo } from "react";
import {
  ILoadWidgetProps,
  IStoreVisibilityParams,
  IStoreVisibility,
} from "./WidgetInstance.interface";
import useAppModelChange from "@src/backbone/hooks/useAppModelChange";

const useWidgetInstanceVisibility = (
  params: ILoadWidgetProps["params"] & IStoreVisibilityParams
) => {
  const [appData] = useAppModelChange(["cart"]);
  const [cartData] = useCartModelChange(["id_store"]);

  const canShowWidget = useMemo(() => {
    
    if (params) {
      const {
        all_store,
        stores = [],
        show_if_no_store: show_if_no_store_raw,
      } = params as ILoadWidgetProps["params"] & IStoreVisibilityParams;
      const show_if_no_store: boolean =
        parseInt(show_if_no_store_raw || "0") === 1;

      if (typeof all_store === "string") {
        if (all_store === IStoreVisibility.NO_LIMITATION) {
          return true;
        }
        const cartIdStore = cartData.id_store;
        let allowed_shop = stores,
          current_shop = cartIdStore;
        if (show_if_no_store && current_shop === "0") {
          return true;
        }
        if (
          allowed_shop &&
          Array.isArray(allowed_shop) &&
          allowed_shop.length > 0
        ) {
          if (
            (all_store === IStoreVisibility.LIMITED_TO_SELECTED_STORE &&
              !allowed_shop.includes(current_shop || "")) ||
            (all_store === IStoreVisibility.EXCLUDED_TO_SELECTED_STORE &&
              allowed_shop.includes(current_shop || ""))
          ) {
            return false;
          }
        }
      }
    }
    return true;
  }, [cartData.id_store, params, appData]);

  return { canShowWidget };
};

export default useWidgetInstanceVisibility;
